module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Just so you know","track":"Just so you know"}}